import { Injectable } from '@angular/core';
import { CanActivate, Router} from '@angular/router';
import { GraphqlService } from './graphql.service';

@Injectable({
  providedIn: 'root'
})
export class PendingContentAgreementCheckService implements CanActivate {

  constructor(private router: Router, private graphQlService: GraphqlService) { }
  canActivate(): boolean {
    this.graphQlService.GetPendingContentAgreementSession().subscribe(data => {
      if (data != null && data.agreementValue === true) {
        this.router.navigate(['pendingcontentsystem']);
        return false;
      }
      else {
        return true;
      }
    });
    return true;
  }
}
